import { CanAccess, HttpError } from '@refinedev/core';
import { DeleteButton, EditButton, TextField, useTable } from '@refinedev/antd';
import { IEcommerceTag } from 'interfaces/ecommerce_tags';
import { ListLayout } from 'components/layout/layout/ListLayout';
import { Space, Table } from 'antd';

export const EcommerceTagList = () => {
  const { tableProps } = useTable<IEcommerceTag, HttpError>();

  return (
    <ListLayout title="Tags">
      <Table {...tableProps} rowKey="id">
        <Table.Column
          dataIndex="name"
          key="name"
          title="Nome"
          render={value => <TextField value={value} />}
        />

        <Table.Column
          dataIndex="description"
          key="description"
          title="Descrição"
          render={value => <TextField value={value} />}
        />

        <Table.Column<IEcommerceTag>
          title="Ações"
          dataIndex="actions"
          align="center"
          width={120}
          render={(_, record) => {
            return (
              <Space>
                <CanAccess resource="tags" action="edit">
                  <EditButton hideText size="small" recordItemId={record.id} />
                </CanAccess>
                <CanAccess resource="tags" action="delete">
                  <DeleteButton
                    hideText
                    size="small"
                    recordItemId={record.id}
                  />
                </CanAccess>
              </Space>
            );
          }}
        />
      </Table>
    </ListLayout>
  );
};
